import * as t from 'io-ts';

import {makeEnumRuntimeType, RLazyTeammateIdRef} from '../../../../models/api/apiTypes';
import {TeammateModel} from '../../../../models/api/teammateModel';

/*
 * Runtime type.
 */

export enum CellsContextTypesEnum {
  TEAMMATE = 'TEAMMATE',
  TEAM = 'TEAM',
  CUSTOM_VIEW = 'CUSTOM_VIEW',
  MIXED_TEAM_TAG = 'MIXED_TEAM_TAG',
  MIXED_SEARCH_GLOBAL_FROM_TEAM = 'MIXED_SEARCH_GLOBAL_FROM_TEAM',
  MIXED_SEARCH_GLOBAL_FROM_TEAMMATE = 'MIXED_SEARCH_GLOBAL_FROM_TEAMMATE',
}

const RCellsContextDirty = t.readonly(
  t.type({
    type: makeEnumRuntimeType(CellsContextTypesEnum),
    /** @deprecated Use buildParametersPath(parameters: InboxesParameters) instead. */
    path: t.string, // Path prefix to navigate to this Context. Used to build links.
    teammateId: RLazyTeammateIdRef,
    namespace: t.union([t.undefined, t.string]),
    teammateInboxTagId: t.Integer,
    inboxId: t.union([t.undefined, t.Integer]),
    searchQuery: t.union([t.undefined, t.string]),
    inTrash: t.boolean,
    inDrafts: t.boolean,
    inSent: t.boolean,
    inSpam: t.boolean,
    isAssignedShared: t.boolean,
    isDelegation: t.boolean,
    inOpenFilter: t.boolean,
    isCellsEmptySetupActionsActive: t.boolean,
  }),
);

/*
 * Type.
 */

export interface CellsContext extends t.TypeOf<typeof RCellsContextDirty> {}
export const RCellsContext = t.clean<CellsContext>(RCellsContextDirty as any);

/*
 * Helpers.
 */

export function makeDefaultCellsContext(user: TeammateModel, isInTeamContext: boolean): CellsContext {
  return {
    type: isInTeamContext ? CellsContextTypesEnum.TEAM : CellsContextTypesEnum.TEAMMATE,
    path: `/inboxes/teammates/${user.id}/inbox/open`,
    namespace: `tea:${user.id}`,
    teammateId: user.id,
    teammateInboxTagId: user.inboxTagId,
    inboxId: undefined,
    searchQuery: undefined,
    inDrafts: false,
    inTrash: false,
    inSent: false,
    inSpam: false,
    isAssignedShared: false,
    isDelegation: false,
    inOpenFilter: true,
    isCellsEmptySetupActionsActive: false,
  };
}
